import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

const styles = {
  container: {
    position: "sticky",
    bottom: "10px",
    width: "100%",
    left: 0,
    zIndex: 99,
    backgroundColor: "white",
  },
};

export default function FormActions({ onNextItem }) {
  return (
    <Box sx={styles.container}>
      <Button fullWidth type="button" variant="contained" color="primary" onClick={onNextItem}>
        Next Item
      </Button>
    </Box>
  );
}
